import _ from "lodash";
import {CrudCollection, Graphql, GraphqlFormSchema} from "@hc/graphql"
import {titleize} from 'inflected'

export class FormulateSchemaBuilder {

  private readonly collection: CrudCollection
  private readonly formSchema: GraphqlFormSchema

  constructor(collection: string|CrudCollection, formSchema?: GraphqlFormSchema){
    this.collection = _.isString(collection) ? Graphql.collection(collection) : collection
    this.formSchema = formSchema || this.collection.formSchema
  }

  build(fields?: string[], ignoreFields?: string[]) {
    const formFields = []
    //let ignore = []
    //if(fields) ignore = ignore.concat(_.without(this.formSchema.fieldNames, ...fields))
    //if(ignoreFields) ignore = [...ignore, ...ignoreFields]
    //const permittedColumns = this.collection.getPermittedColumns()
    //permittedColumns = Object.keys(this.formSchema.fields).filter(field => !permittedColumns || permittedColumns.includes(field))
    //console.log("FIELDS", fields, ignoreFields)
    //console.log("PERMITTED", permittedColumns)

    //console.log("BUILD SCHEMA", this.collection.name)

    for(const fieldName of this.formSchema.fieldNames) {
      // handle blacklisted fields if applicable
      if(ignoreFields && ignoreFields.indexOf(fieldName) >= 0) continue
      // handle whitelisted fields if applicable
      if(fields && fields.indexOf(fieldName) < 0) continue

      // gather metadata
      const schema = this.formSchema.fields[fieldName]
      const meta = this.formSchema.fieldMeta(fieldName)
      const flags = this.formSchema.fieldFlags(fieldName)
      const options = {...meta, ...flags}
      //console.log("FIELD", fieldName, schema.type)
      //console.log("OPTIONS", options)

      // build formulate base field
      const field: Record<string, any> = {
        name: fieldName,
        column: fieldName,
        type: 'text',
        label: titleize(fieldName),
        validationName: titleize(fieldName),
        default: options.default,
        joiOptions: options,
      }

      if(options.presence == 'required') field.validation = 'required'

      // type specific field customization
      switch(schema.type){
        case 'string':
          field.type = 'text'
          break
        case 'number':
          field.type = 'number'
          break
        case 'time':
          field.type = 'time'
          break
        case 'text':
          field.type = 'textarea'
          break
        case 'boolean':
          field.type = 'checkbox'
          break
        case 'date':
          field.type = 'date'
          break
        case 'email':
          field.name = 'mail'
          field.label = 'Email'
          field.type = 'email'
          field.validation = 'bail|email|required'
          field.validationName = 'Email'
          break
        case 'phone':
          field.name = 'phone'
          field.label = 'Phone'
          field.type = 'text'
          field.validation = 'bail|phone|required'
          // field.validationName = 'Phone'
          break
        case 'enum':
          field.type = "select"
          if(options.itemMap){
            //console.log("   ENUM map",schema.allow)
            field.options = Object.keys(options.itemMap).map((name)=>{
              return {value: name, label: options.itemMap[name]}
            })
          } else {
            //console.log("   ENUM simple",schema.allow)
            field.options = schema.allow
          }
          break
        case 'attributes':
          field.type = 'attributes'
          // label will be rendered for each attribute type
          field.label = null
          field.definition = options.definition
          break
        case 'join':
          if(options.composition){
            field.type = 'joinComposition'
            const joinSchemaBuilder = new FormulateSchemaBuilder(options.collection)
            field.fields = joinSchemaBuilder.build()
          } else {
            field.type = 'joinAssociation'
          }
          field.collection = options.collection
          // we operate on the joined objects data instead of the foreign key
          field.name = fieldName.replace(/_id$/, '')
          if (options.constrain) {
            //console.log("   CONSTRAIN", options.constrain)
            field.constrain = options.constrain
          }
          break
        case 'relation':
          // not a tale column
          field.column = null
          if(options.association){
            field.type = 'relationAssociation'
            field.collection = options.collection
            field.owner = options.association.owner
            field.remote = options.association.remote
          } else {
            console.error('Currently only relation association is implemented!')
            continue
          }
          break
        default:
          console.warn(`Unknown schema type: ${schema.type} for field ${fieldName}!`)
          continue
      }

      // handle hidden/readonly fields
      if(options.readonly || options.hidden || options.calculated) {
        //console.log("HIDDEN", fieldName, field)
        field.type = 'hidden'
        field.label = null
      }

      // check user has access to the database column
      if(field.column){
        if(!this.collection.isColumnPermitted(field.column, 'update')){
          //console.log("FILTER field without access on " + field.column)
          continue
        }
      }

      formFields.push(field)
    }
    return formFields
  }
}